import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

// Lazy-loaded components
const LazyFactorClientMatchingDashboardRoute = lazy(() =>
  retry(() => import('app/pages/admin/FactorClientMatching/Dashboard')));
const LazyFactorClientMatchingNextRoute = lazy(() =>
  retry(() => import('app/pages/admin/FactorClientMatching/Next')));
const LazyFactorClientMatchingShowRoute = lazy(() =>
  retry(() => import('app/pages/admin/FactorClientMatching/Show')));

// Export component wrappers
export const FactorClientMatchingDashboard = (props: ComponentProps) => (
  <LazyFactorClientMatchingDashboardRoute {...props} />
);
export const FactorClientMatchingNext = (props: ComponentProps) => (
  <LazyFactorClientMatchingNextRoute {...props} />
);
export const FactorClientMatchingShow = (props: ComponentProps) => (
  <LazyFactorClientMatchingShowRoute {...props} />
);
